<template>

<v-app>
    <TopBar  />
    <LeftMenu ></LeftMenu>
    <Vtoast ref="Vtoast" :callBack="vtoastCallback" />

    <div class="pa-5" >
      
      <v-card elevation="0" outlined>
        <v-card-title>Edit Leaflet</v-card-title>
        <v-card-subtitle>{{this.bookName}} - {{this.unitName}}</v-card-subtitle>

        <div class="pa-5"> 
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field outlined v-model="leafletName"  :rules="nameRules" label="Leaflet Name" required ></v-text-field>
          </v-form>
        </div>

        <v-card-actions class="pt-0" >
          <v-spacer></v-spacer>
          <v-btn :to="'/eisadmin/leaflets/'+unitId" color="error" small elevation="0" class="mb-2 mr-2 mt-2" >CANCEL</v-btn>
          <v-btn class="float-right" @click="submit" small color="primary" >Save</v-btn>
        </v-card-actions>

      </v-card>

    </div>

</v-app>

</template>

<script>

  import checkAuth from '../../mixins/checkAuth';
  import LeftMenu from '../../views/eisadmin/components/LeftMenu'
  import TopBar from '../../views/eisadmin/components/TopBar'
  import { mdiMagnify, mdiBellOutline, mdiGithub, mdiAlertRhombus, mdiCheckBold } from '@mdi/js'
  import axios from 'axios';
  import Vtoast from '../../views/eisadmin/components/Vtoast';


  export default {
    mixins: [checkAuth],
    components: { LeftMenu, TopBar, Vtoast },

    setup() {
      return {
        icons: {
          mdiMagnify, mdiBellOutline, mdiGithub,},
      }
    },

    data: () => ({
      valid: true,
      bookName: '',
      unitName: '',
      leafletName: '',
      unitId : '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length >= 1) || 'Name must be more than 2 characters',
      ],
    }),

    methods: {
      getData(leafletId) {
        
        const data = { leafletId : leafletId }
        axios.post(process.env.VUE_APP_API_DOMAIN + "/leaflet",JSON.stringify(data)
        ,{ headers: {'Authorization': 'Bearer ' + this.$store.getters.getAccessToken } })
        .then(
          response => {
            this.leafletName = response.data.leaflet.leafletName;
            this.unitName = response.data.unitName;
            this.bookName = response.data.bookName;
            this.unitId = response.data.unitId;
          }  
        );

      },
      submit () {
        
        if(this.$refs.form.validate()){
          
          const data = {
            leafletName : this.leafletName,
            leafletId : this.$route.params.leafletId
          }

          axios.post(process.env.VUE_APP_API_DOMAIN + "/leaflet_save",JSON.stringify(data)
          ,{
              headers: {
                'Authorization': 'Bearer ' + this.$store.getters.getAccessToken  
              }
            }
          ).then(
            response => {
              console.log(response);
              if(response.data.result == "success"){
                this.$root.Vtoast.show({message: 'Leaflet is saved succesfully!', snackType: 'success', color: 'success', icon: mdiCheckBold })
              }else{
                this.$root.Vtoast.show({message: 'An error occurred!', snackType: 'fail', color: 'warning', icon: mdiAlertRhombus})
              }

            }  

          );

        }

      },
      vtoastCallback() {
        //vtoastCallback
        this.$router.push(`/eisadmin/leaflets/${this.unitId}`);
      }
      
    },


    created() {

    },
    mounted() {
      this.$root.Vtoast = this.$refs.Vtoast
      this.getData(this.$route.params.leafletId);
    },
  }
</script>

